/**
 * Utilities for `<!--ppt_slides:...-->` embedded JSON in generated document HTML (PPTX export).
 */

/**
 * Parse slide definitions from a document HTML string produced by the presentation pipeline.
 * @param {string|null|undefined} htmlContent - Full stored HTML.
 * @returns {{ type: string, content: string }[]|null} Slide array or null if missing/invalid.
 */
export function extractSlidesJsonFromDocumentHtml(htmlContent) {
  if (!htmlContent || typeof htmlContent !== 'string') {
    return null;
  }
  const m = htmlContent.match(/<!--ppt_slides:([^>]*)-->/);
  if (!m) {
    return null;
  }
  try {
    const parsed = JSON.parse(decodeURIComponent(m[1]));
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

/**
 * Build presentation HTML with embedded slides comment (mirrors Cloud Run worker output).
 * @param {string} documentTitle - Title for the article header.
 * @param {{ type: string, content: string }[]} filledSlides - Slides after AI fill.
 * @returns {string} HTML document string.
 */
export function buildPresentationDocumentHtml(documentTitle, filledSlides) {
  const escapeHtml = (text) =>
    String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const exportSlides = filledSlides.map(({ type, content }) => ({ type, content }));
  const encoded = encodeURIComponent(JSON.stringify(exportSlides));
  const sections = filledSlides
    .map(
      (s, i) =>
        `<section class="ppt-slide" data-slide-index="${i}" data-slide-type="${escapeHtml(String(s.type))}"><div class="ppt-slide-inner">${s.content}</div></section>`
    )
    .join('\n');
  const title = escapeHtml(documentTitle || 'Presentation');
  return `<article class="quill-presentation"><header class="ppt-meta"><h1 class="ppt-title">${title}</h1></header>\n${sections}\n</article>\n<!--ppt_slides:${encoded}-->`;
}
